export default {
    // General
    loading: 'Chargement',
    home: 'Accueil',
    back: 'Retour',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    close: 'Fermer',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    yes: 'Oui',
    no: 'Non',
    or: 'ou',
    and: 'et',
    required: 'Obligatoire',
    optional: 'Optionnel',

    // Store status
    storeOpen: 'Ouvert',
    storeClosed: 'Fermé',
    storeOpenSoon: 'Ouvre bientôt',

    // Navigation
    categories: 'Catégories',
    siteMap: 'Plan du site',
    cart: 'Panier',
    myAccount: 'Mon compte',

    // Auth
    login: 'Connexion',
    register: "S'inscrire",
    logout: 'Déconnexion',
    forgotPassword: 'Mot de passe oublié ?',
    rememberMe: 'Se souvenir de moi',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    noAccount: "Vous n'avez pas de compte ?",
    signIn: 'Se connecter',

    // Form fields
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmation de mot de passe',
    firstName: 'Prénom',
    lastName: 'Nom',
    phone: 'Téléphone',
    address: 'Adresse',
    city: 'Ville',
    postalCode: 'Code postal',
    country: 'Pays',

    // Password rules
    passwordRules: 'Le mot de passe doit contenir : au moins 10 caractères, une majuscule, une minuscule, un chiffre, un caractère spécial',
    confirmPasswordMessage: 'Veuillez confirmer votre mot de passe',
    passwordValid: 'Mot de passe valide',
    passwordInvalid: 'Mot de passe invalide',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordMissingLength: 'au moins {min} caractères',
    passwordMissingUppercase: 'une majuscule',
    passwordMissingLowercase: 'une minuscule',
    passwordMissingNumber: 'un chiffre',
    passwordMissingSpecial: 'un caractère spécial',
    optionFreeRemaining: 'Vous pouvez sélectionner encore {count} option gratuite !',
    optionSelectAtLeastOne: 'Vous devez sélectionner au moins une option !',
    optionSelectionRequired: 'Une sélection est requise pour cette option !',
    mustAcceptTerms: "Vous devez accepter les conditions d'utilisation.",
    registerFormAlreadySubmitted: "Le formulaire d'inscription a bien été soumis, veuillez patienter !",
    newPassword: 'Nouveau mot de passe',
    oldPassword: 'Ancien mot de passe',
    verifyingInfo: 'Nous vérifions vos informations',
    contactUs: 'Veuillez nous contacter !',
    invalidInfo: 'Vos informations sont invalides',
    deleteAccountRequest: 'Demande de suppression de compte',
    deleteAccountConfirmText: 'Si vous souhaitez supprimer votre compte, veuillez entrer votre mot de passe',

    // Terms
    acceptTerms: "Accepter les conditions d'utilisation",
    privacyPolicy: 'Politique de confidentialité',
    termsOfUse: "Conditions générales d'utilisation",

    // Product
    select: 'Sélectionner',
    addToCart: 'Ajouter',
    options: 'Options',
    description: 'Description',
    noDescription: 'Aucune description',
    nameUnavailable: 'Nom non disponible',
    someOptionsPaid: 'certaines options sont payantes',

    // Cart / Order
    cartTitle: 'Panier',
    cartSummary: 'Récapitulatif du panier',
    orderCommand: 'Commander',
    validateOrder: 'Valider la commande',
    total: 'Total',
    subtotal: 'Sous-total',
    deliveryFees: 'Frais de livraison',
    free: 'gratuit',
    paid: 'payant',
    orderPaid: 'Réglé',
    orderUnpaid: 'Non réglé',
    maximum: 'maximum',
    quantity: 'Quantité',

    // Payment
    payByCard: 'Payer par carte',
    payOnSite: 'Payer sur place',
    paymentSuccess: 'Paiement réussi',
    paymentError: 'Erreur de paiement',

    // Delivery
    delivery: 'Livraison',
    pickup: 'À emporter',
    tableReservation: 'Réservation de table',
    deliveryZones: 'Zones de livraison',
    deliveryFee: 'Frais de livraison',
    minimumOrder: 'Commande minimum',
    freeFrom: 'Gratuit à partir de',

    // Dashboard
    dashboard: 'Tableau de bord',
    orderHistory: 'Historique des commandes',
    addressBook: "Carnet d'adresses",
    setDefault: 'Par défaut',
    requestAccessCode: 'Demander un code pour accéder à votre compte',
    code: 'Code',
    myInfo: 'Mes informations',
    myAddresses: 'Mes adresses',
    addAddress: 'Ajouter une adresse',
    editAddress: 'Modifier une adresse',
    deleteAddress: 'Supprimer une adresse',
    deleteAccount: 'Supprimer mon compte',
    modifyPassword: 'Modifier le mot de passe',
    cancelAccountDeletion: 'Annulation de suppression de compte',
    loginToOrder: 'Vous devez être connecté pour commander',
    send: 'Envoyer',
    missingFields: 'Champ(s) manquant(s) ou invalide(s)',
    forgotPasswordDescription: 'Entrez votre adresse e-mail pour réinitialiser votre mot de passe',
    enterEmail: 'Entrez votre adresse e-mail',
    forgotPasswordTitle: 'Mot de passe oublié',
    passwordResetTitle: 'Réinitialisation du mot de passe',
    disconnectSuccess: 'Déconnexion réussie',
    captchaRequired: 'Veuillez compléter le captcha',
    captchaLoading: 'Chargement du captcha...',
    captchaError: 'Erreur avec le captcha. Veuillez réessayer.',
    retry: 'Réessayer',
    productAddedSuccess: 'Votre produit a bien été ajouté !',
    productAssociatedSuggestion: 'Les clients vous conseillent également ces produits pour accompagner votre sélection.',
    productAssociatedTitle: 'Produit(s) associé(s)',
    removeProductQuestion: 'Voulez-vous retirer ce produit du panier ?',
    waitBeforeRetry: 'Veuillez patienter avant de cliquer à nouveau',
    fillRequiredFields: 'Veuillez remplir tous les champs obligatoires',
    otpInvalid: 'Veuillez entrer un code OTP valide',
    otpSendError: "Erreur lors de l'envoi du code OTP",
    infoUnchanged: "Les informations n'ont pas changé",
    selectAddressToModify: 'Veuillez sélectionner une adresse pour la modifier',
    orderPlacedSuccess: 'Commande passée avec succès !',
    paymentSuccessMessage: 'Félicitations, votre paiement a été effectué avec succès !',
    orderTransmittedRestaurant: 'Votre commande a bien été transmise au restaurant',
    orderNumberLabel: 'Numéro de commande :',
    pickupOrderMessage: 'Vous pouvez récupérer la commande pour :',
    wishGoodDayMeal: 'En vous souhaitant une bonne journée et un agréable repas',
    wishGoodAfternoonMeal: 'En vous souhaitant une bonne après-midi et un agréable repas',
    wishGoodEveningMeal: 'En vous souhaitant une bonne soirée et un agréable repas',
    addressNotFound: 'Adresse introuvable',
    accountDeletionTitle: 'Suppression du compte',
    accountDeletionCancelError: "Erreur d'annulation de suppression de compte",
    personalInfoTitle: 'Informations personnelles',
    selectAddressTitle: 'Sélectionner une adresse',
    selectedAddressNotFound: "L'adresse sélectionnée n'a pas été trouvée",
    todayOrders: "Commandes d'aujourd'hui",
    previousOrders: 'Anciennes commandes',
    order: 'Commande',
    pickupTime: 'Heure de récupération',
    notConfirmed: 'Non confirmée',
    cancelled: 'Annulée',
    company: 'Société',
    addressComplement: "Complément d'adresse",
    region: 'Région',
    selectRegion: 'Sélectionner une région',
    selectCity: 'Sélectionner une ville',
    address1: 'Adresse 1',
    // refactored — address form'a özel key'ler. TR: Bölge / Mahalle / Cadde.
    addressFormZoneLabel: 'Région',
    addressFormCityLabel: 'Ville',
    addressFormStreetLabel: 'Adresse',
    addressFormSelectZone: 'Sélectionner une région',
    addressFormSelectCity: 'Sélectionner une ville',
    addressSearchPlaceholder: 'Rechercher une adresse (rue, avenue, bâtiment…)',
    addressMapHint: 'Cliquez sur la carte ou glissez le marqueur pour choisir le point exact.',
    addressMapPicked: 'Point sélectionné',
    defaultAddressQuestion: 'Adresse par défaut',
    mandatory: 'Obligatoire',
    noOrdersYet: "Vous n'avez pas encore de commande",
    noAddressesYet: "Vous n'avez pas encore d'adresse enregistrée",
    cartEmpty: 'Le panier est vide',
    storeClosedLong: 'Le magasin est fermé',

    // Order validation page
    fullName: 'Nom et prénom',
    orderOptions: 'Options de commande',
    pickupMethod: 'Méthode de récupération',
    withdrawTitle: 'Retrait',
    paymentMethod: 'Méthode de paiement',
    asSoonAsPossible: 'Dès que possible',
    todayLabel: "Aujourd'hui",
    existingAddress: 'Adresse existante',
    newAddress: 'Nouvelle adresse',
    addressAddedSuccess: 'Votre nouvelle adresse a été ajoutée avec succès.',
    selectDeliveryAddress: 'Veuillez sélectionner une adresse de livraison.',
    priceDoesntMeetDelivery: 'Le prix ne remplit pas les conditions de livraison',
    restaurantDoesntAcceptPickupDelivery: "Le restaurant n'accepte pas la récupération des produits ou la livraison",
    storeCannotTakeOrderNow: 'Le restaurant ne peut pas prendre votre commande pour le moment. Merci de la passer ultérieurement',
    cardMinimumAmount: 'Pour commander par carte, le montant total de la commande doit être {amount} ou plus.',
    hourLabel: 'Heure',
    minuteLabel: 'Minute',
    addressPlaceholder: 'Adresse',
    emptyBasketProducts: 'Aucun produit dans le panier',
    taxIncluded: 'TVA ({rate}%) Inclus',
    shippingTaxIncluded: 'TVA des frais de livraison ({rate}%) Inclus',
    withShippingFees: 'avec frais de livraison',
    addCommentPlaceholder: 'Vous pouvez ajouter un commentaire',
    demoCannotOrder: 'Ce site est une démonstration vous ne pouvez pas commander',
    demoCannotPassOrder: 'Vous ne pouvez pas passer commande ce site est une démonstration',
    validateInformationButton: 'Valider les informations',
    termsValidationIntro: 'En validant cette commande, vous confirmez avoir pris connaissance et accepté nos',
    termsValidationMiddle: 'ainsi que notre',
    termsValidationEnd: 'Nous vous encourageons à les lire attentivement avant de finaliser votre achat',

    // Store status banner
    storeOpensAt: 'Ouvre à {time}',
    storeClosedOpensOn: 'Fermé, ouvre {day} à {time}',
    storeOrderOpenOpensAt: 'Le système de commande est actif, vous pouvez passer votre commande maintenant et la récupérer à partir de {time}.',
    storeOpenOrderClosed: 'Magasin Ouvert - Commande Fermée',
    dayFullSunday: 'Dimanche',
    dayFullMonday: 'Lundi',
    dayFullTuesday: 'Mardi',
    dayFullWednesday: 'Mercredi',
    dayFullThursday: 'Jeudi',
    dayFullFriday: 'Vendredi',
    dayFullSaturday: 'Samedi',

    // Order status
    orderPending: 'En attente',
    orderPreparation: 'En préparation',
    orderReady: 'Prêt',
    orderDelivered: 'Livré',
    orderCancelled: 'Annulé',

    // Footer
    openingHours: "Heures d'ouverture",
    pickupService: 'Heures de retrait',
    deliveryService: 'Heures de livraison',
    allRightsReserved: 'Tous droits réservés',
    dayShortMon: 'Lun',
    dayShortTue: 'Mar',
    dayShortWed: 'Mer',
    dayShortThu: 'Jeu',
    dayShortFri: 'Ven',
    dayShortSat: 'Sam',
    dayShortSun: 'Dim',

    // Errors
    error: 'Erreur',
    attention: 'Attention',
    networkError: 'Erreur réseau',
    unauthorized: 'Non autorisé',

    // Validation errors (backend keys)
    phone_missing: 'Numéro de téléphone manquant',
    phone_invalid: "Le numéro de téléphone n'est pas valide",
    lastname_missing: 'Nom de famille manquant',
    lastname_invalid: "Le nom de famille n'est pas valide",
    firstname_missing: 'Prénom manquant',
    firstname_invalid: "Le prénom n'est pas valide",
    password_missing: 'Mot de passe manquant',
    password_rules_violated: 'Le mot de passe ne respecte pas les règles',
    password_confirm_missing: 'Confirmation du mot de passe manquante',
    password_confirm_rules_violated: 'La confirmation du mot de passe ne respecte pas les règles',
    password_mismatch: 'Les mots de passe ne correspondent pas',
    store_name_missing: 'Nom du magasin manquant',
    store_name_invalid: "Le nom du magasin n'est pas valide",
    language_missing: 'Langue manquante',
    language_invalid: "La langue n'est pas valide",
    customer_missing: 'Informations client manquantes',
    customer_invalid: 'Informations client non valides',
    store_missing: 'Informations du magasin manquantes',
    store_invalid: 'Informations du magasin non valides',
    remember_me_invalid: 'Option "Se souvenir de moi" non valide',
    email_missing: 'Adresse e-mail manquante',
    email_invalid: "L'adresse e-mail n'est pas valide",
    email_domain_invalid: "Le domaine de l'adresse e-mail n'est pas valide",
    address_fields_missing: "Champs d'adresse manquants",
    zone_missing: 'Zone manquante',
    city_missing: 'Ville manquante',
    city_invalid: "La ville n'est pas valide",
    city_too_short: 'Ville trop courte',
    city_too_long: 'Ville trop longue',
    supaddress_missing: "Complément d'adresse manquant",
    supaddress_too_short: "Complément d'adresse trop court",
    supaddress_too_long: "Complément d'adresse trop long",
    supaddress_invalid: "Le complément d'adresse n'est pas valide",
    address_missing: 'Adresse manquante',
    address_too_short: 'Adresse trop courte',
    address_too_long: 'Adresse trop longue',
    address_invalid: "L'adresse n'est pas valide",
    company_name_too_short: "Nom de l'entreprise trop court",
    company_name_too_long: "Nom de l'entreprise trop long",
    company_name_invalid: "Le nom de l'entreprise n'est pas valide",
    address_id_missing: 'ID adresse manquant',
    address_id_invalid: "L'ID d'adresse n'est pas valide",

    // Backend messages (snake_case keys)
    invalid_data: 'Les données ne sont pas bonnes',
    terms_not_accepted: "Vous devez accepter les conditions générales d'utilisation",
    generic_error: 'Une erreur est survenue ! Si le problème persiste contactez le magasin.',
    session_expired: 'Votre session a expiré. Veuillez vous reconnecter.',
    token_invalid_or_expired: 'Token invalide ou expiré',
    refresh_token_missing: 'Refresh token manquant',
    refresh_token_invalid: 'Refresh token invalide ou expiré',
    token_refresh_success: 'Token rafraîchi avec succès',
    captcha_failed: 'La vérification du captcha a échoué',
    email_already_used: 'Cet email est déjà utilisé',
    register_error_generic: "Une erreur est survenue pour ajouter un client",
    register_error_retry: "Vous avez rencontré une erreur lors de l'ajout de votre compte, veuillez réessayer",
    register_success_verify_email: 'Inscription réussie. Veuillez vérifier votre email',
    confirm_register_error: "Erreur de confirmation d'inscription",
    store_id_invalid: "L'identifiant du magasin est incorrect",
    store_id_mismatch: "L'identifiant du magasin ne correspond pas",
    store_not_found: 'Le magasin est introuvable',
    store_setting_not_found: 'Setting introuvable',
    store_privacy_policy_not_found: 'PrivacyPolicy introuvable',
    store_condition_use_not_found: 'ConditionUse introuvable',
    store_theme_not_found: 'Theme introuvable',
    store_no_categories: 'Aucune catégorie associée à ce magasin',
    store_no_category_ids: 'Aucune catégorie trouvée avec ces identifiants',
    store_load_error: 'Nous avons rencontré une erreur dans le chargement des données du magasin',
    user_not_found: "L'utilisateur n'existe pas",
    customer_id_invalid: "L'identifiant de l'utilisateur est incorrect",
    customer_id_missing: "L'identifiant de l'utilisateur est manquant",
    customer_fetch_error: "Vous rencontrez un problème lors de la récupération des informations de l'utilisateur",
    customer_error_generic: 'Erreur utilisateur',
    customer_data_missing: 'Données client manquantes',
    customer_data_invalid: 'Données client incorrectes',
    email_not_verified: "L'utilisateur n'a pas vérifié son email",
    email_not_verified_cannot_modify_password: "L'utilisateur n'a pas vérifié son email, vérifiez-le avant de faire une modification",
    email_or_password_invalid: "L'adresse e-mail ou le mot de passe est invalide.",
    email_or_store_invalid: 'Email ou magasin invalide',
    email_already_confirmed: 'Vous avez déjà confirmé votre email',
    email_confirmed_success: 'Votre email est valide, vous allez être redirigé',
    password_incorrect: "Le mot de passe n'est pas correct",
    password_invalid: 'Le mot de passe est invalide.',
    old_password_invalid: "L'ancien mot de passe n'est pas valide",
    password_reset_link_active: 'Un lien de ré-initialisation de mot de passe est actif',
    reset_link_already_active: 'Un lien de ré-initialisation est déjà actif. Veuillez vérifier votre e-mail',
    reset_token_expired: 'La modification a expirée, veuillez faire une nouvelle demande',
    reset_token_expired_retry: 'Jeton invalide ou expiré, faites une nouvelle demande',
    forget_password_email_sent: 'Vous allez recevoir un email pour modifier votre mot de passe',
    forget_password_error: "Erreur lors de la demande d'oubli de mot de passe",
    password_reset_success: 'Votre mot de passe a bien été modifié !',
    password_reset_error: 'Erreur lors de la mise à jour du mot de passe oublié',
    user_cannot_change_password: 'L\'utilisateur ne peut pas changer son mot de passe !',
    user_cannot_modify_password: "L'utilisateur ne peut pas modifier son mot de passe",
    verify_modify_success: "L'utilisateur peut modifier son mot de passe",
    update_success: 'Les informations ont été mises à jour avec succès.',
    update_error: 'Erreur lors de la mise à jour des données !',
    update_password_success: 'Le mot de passe a été mis à jour avec succès.',
    update_password_success_redirect: 'Votre mot de passe a bien été modifié, vous serez redirigé',
    update_password_error: 'Erreur lors de la mise à jour du mot de passe',
    user_pending_deletion: "L'utilisateur a fait une demande de suppression",
    account_pending_deletion_service_denied: 'Votre compte a fait une demande de suppression de compte',
    user_no_deletion_request: "L'utilisateur n'a pas fait de demande de suppression de compte",
    user_archived: "L'utilisateur a été archivé",
    user_deleted_success: 'Votre compte a été supprimé avec succès',
    delete_user_error: 'Une erreur est survenue lors de la suppression de votre compte',
    delete_request_success: 'Votre demande de suppression de compte a bien été enregistrée',
    delete_request_error: "Une erreur s'est produite lors de la demande de suppression de compte.",
    cancel_delete_success: 'Votre demande de suppression de compte a été annulée avec succès.',
    cancel_delete_success_with_warning: 'La demande de suppression de compte a été annulée avec succès. Pour augmenter la sécurité, pensez à mettre à jour votre mot de passe.',
    account_verification_error: "Une erreur s'est produite lors de la vérification du compte.",
    login_success: 'Connexion réussie, vous allez être redirigé',
    login_success_old_password: 'Connexion réussie, vous allez être redirigé. Pour augmenter la sécurité, mettez à jour votre mot de passe',
    login_error_generic: 'Une erreur est survenue lors de votre tentative de connexion',
    disconnect_success: 'Déconnexion réussie',
    disconnect_error: 'Une erreur est survenue lors de votre tentative de déconnexion',
    me_success: 'Informations récupérées avec succès',
    fetch_me_error: 'Une erreur est survenue lors de la récupération de vos informations.',
    otp_request_success: 'La demande de code est valide',
    otp_request_error: "Une erreur s'est produite lors de la demande de code.",
    otp_valid: 'Code valide, vous pouvez modifier vos informations',
    otp_invalid: 'Code invalide, vérifiez votre code',
    otp_already_used: "Vous avez déjà utilisé votre code d'accès",
    otp_verification_error: "Une erreur s'est produite lors de la vérification du code.",
    otp_verification_success: "Le code d'accès a été vérifié avec succès.",
    otp_send_success: "Le code d'accès a été envoyé par e-mail.",
    otp_send_error: "Une erreur est survenue lors de l'envoi du code d'accès",
    city_or_postal_invalid: 'La ville ou le code postal est invalide',
    address_duplicate: 'Une adresse identique existe déjà pour cette ville.',
    address_not_found: "Cette adresse n'existe pas",
    address_not_found_for_customer: 'Aucune adresse trouvée pour ce client.',
    address_id_missing_or_invalid: "L'identifiant de l'adresse est invalide ou manquant",
    address_limit_reached: "Vous avez atteint la limite maximale d'adresses autorisées.",
    address_added_success: 'Votre adresse a bien été enregistrée.',
    address_added_success_default: 'Votre adresse a bien été enregistrée par défaut.',
    address_added_error: "Une erreur s'est produite pour ajouter une adresse",
    address_update_success: 'Votre adresse a bien été modifiée',
    address_update_success_default: 'Votre adresse a bien été modifiée et enregistrée par défaut',
    address_update_error: "Une erreur est survenue lors de la modification de l'adresse",
    address_delete_success: "L'adresse a été supprimée",
    address_delete_error: "Erreur lors de la suppression de l'adresse",
    address_fetch_error: "Erreur lors de la récupération des données d'adresses !",
    order_too_many_requests: 'Trop de requêtes. Veuillez patienter avant de recommencer.',
    order_price_mismatch: 'Le prix envoyé ne correspond pas avec les données.',
    order_created_success: 'Commande créée',
    order_creation_error: 'Erreur lors de la création de la commande',
    order_cancelled_success: 'Commande modifiée',
    order_cancel_error: 'Erreur',
    order_id_missing: 'OrderId manquant',
    order_id_invalid: "L'orderId n'est pas bon",
    orders_not_found: 'Aucune commande trouvée',
    orders_fetch_success: 'Commandes récupérées avec succès',
    order_stripe_failed: 'La création de la session de paiement a échoué. Veuillez contacter le restaurant.',
    pay: 'Payer',
    amountUnavailable: 'Montant non disponible',

    // Legal pages (CGU / Privacy Policy)
    cguTitle: "Conditions générales d'utilisation",
    privacyTitle: 'Politique de confidentialité',
    lastUpdated: 'Dernière mise à jour :',
    cguIntro: "Les présentes conditions générales d'utilisation (CGU) régissent l'utilisation du site https://{hostname} et de ses services. En accédant à ce site et en l'utilisant, vous acceptez d'être lié par les présentes conditions. Si vous n'acceptez pas ces termes, veuillez ne pas utiliser notre site.",
    privacyWelcomeBefore: 'Bienvenue sur ',
    privacyWelcomeAfter: ', nous proposons un service de commande en ligne.',
    privacyIntro: 'La présente politique de confidentialité explique comment nous collectons, utilisons et protégeons vos données personnelles.',
    contactLabel: 'Contact :',

    // Page titles (browser tab)
    productCatalog: 'Catalogue de produits',
    productDetails: 'Produit',
    registerTitle: 'Inscription',
    confirmRegistration: "Confirmation d'inscription",
    cartOrderTitle: 'Panier - Commande',
    dashboardEditInfo: 'Tableau de bord - Modification des informations personnelles',
    dashboardEditPassword: 'Tableau de bord - Modification du mot de passe',
    dashboardAddresses: 'Tableau de bord - Gestion des adresses',
    dashboardOrders: 'Tableau de bord - Historique des commandes',

    // Language names
    languages: {
        tr: 'Türkçe',
        fr: 'Français',
        en: 'English',
        de: 'Deutsch'
    }
}
